import { Row } from 'antd'
import List from 'app/components/Core/MachineGroup/List'
import Alert from 'app/components/UI-Elements/Feedback/Alert'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

type Props = {
  interactionType: 'extend' | 'vacant'
  multiple: boolean
  collection: IMachineGroup[]
  loading: boolean
}

const Confirmation: React.FC<Props> = ({ interactionType, multiple, loading, collection }) => {
  const { tRoute } = useTranslation({ scope: 'rental.machine_interaction' })

  const getNotificationData = () => {
    if (interactionType === 'extend') {
      return {
        title: tRoute({ id: 'rental_extension_title' }),
        description: tRoute({ id: 'rental_extension_description' })
      }
    } else {
      if (multiple) {
        return {
          title: tRoute({ id: 'rental_vacant_title_multiple' }),
          description: tRoute({ id: 'rental_vacant_description_multiple' })
        }
      } else {
        return {
          title: tRoute({ id: 'rental_vacant_title_one' }),
          description: tRoute({ id: 'rental_vacant_description_one' })
        }
      }
    }
  }

  return (
    <Row gutter={[0, 24]}>
      <KCol span={24}>
        <Alert
          showIcon={true}
          type="success"
          message={getNotificationData().title}
          description={
            <Row align="middle" justify="space-between" gutter={[12, 12]}>
              <KCol>
                <span>{getNotificationData().description}</span>
              </KCol>
            </Row>
          }
        />
      </KCol>
      <KCol span={24}>
        <span className="text-bold text-heading">{tRoute({ id: 'running_machine' })}</span>
      </KCol>
      <KCol span={24}>
        <List collection={collection} props={{ loading, showDates: true, showStatus: true }} />
      </KCol>
    </Row>
  )
}

export default Confirmation
